/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Photos_DropInputs */

const cs_projects_photos_drop = /** @type {(inputs: Projects_Photos_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přetáhněte fotky sem, nebo použijte Přidat fotky.`)
};

const en_projects_photos_drop = /** @type {(inputs: Projects_Photos_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop photos here, or use Add photos.`)
};

/**
* | output |
* | --- |
* | "Drop photos here, or use Add photos." |
*
* @param {Projects_Photos_DropInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_photos_drop = /** @type {((inputs?: Projects_Photos_DropInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Photos_DropInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_photos_drop(inputs)
	return cs_projects_photos_drop(inputs)
});